import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import ModernDashboard from './pages/ModernDashboard';
import Setup from './pages/Setup';
import MessageHistory from './pages/MessageHistory';
import Apps from './pages/Apps';
import Settings from './pages/Settings';
import AdminPanel from './pages/AdminPanel';
import PrivateRoute from './components/PrivateRoute';
import AppShell from './components/AppShell';

const queryClient = new QueryClient();

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Navigate to="/dashboard" replace />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <AppShell>
                      <ModernDashboard />
                    </AppShell>
                  </PrivateRoute>
                }
              />
              <Route
                path="/setup"
                element={
                  <PrivateRoute>
                    <Setup />
                  </PrivateRoute>
                }
              />
              <Route path="/verify-phone" element={<Navigate to="/setup" replace />} />
              <Route
                path="/messages"
                element={
                  <PrivateRoute>
                    <AppShell>
                      <MessageHistory />
                    </AppShell>
                  </PrivateRoute>
                }
              />
              <Route
                path="/apps"
                element={
                  <PrivateRoute>
                    <AppShell>
                      <Apps />
                    </AppShell>
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <AppShell>
                      <Settings />
                    </AppShell>
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <PrivateRoute>
                    <AppShell>
                      <AdminPanel />
                    </AppShell>
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default App;